export const RDY_FOR_VALIDATION = "Import In Progress"; // state#1
export const VALIDATION_IN_PROGRESS = "Import In Progress"; //after  submitted to PDF
export const VALIDATION_COMPLETE = "Import In Progress";
export const VALIDATION_FAILED = "Import Failed";  // PDF returned invalid Json file. 
export const VALIDATION_ERROR = "Import Failed";  //PDF validated  Errors returned. 
export const RDY_FOR_IMPORT = "Import In Progress";//PDF  validated, and no errors and handover to PCX
export const IMPORT_FAILURE = "Import Failed";
export const IMPORT_SUCCESS = "Import Successful";
export const IMPORT_ERROR = "Import Failed";
export const IMPORT_RUNTIME_ERROR="Import Failed";
export const IMPORT_INVALID_FILE_ERROR="Import Failed";
export const IMPORT_BAD_REQUEST_ERROR="Import Failed";
export const IMPORT_IN_PROGRESS = "Import In Progress";
export const IMPORT_FAILED = "Import Failed";
export const IMPORT_BOM_CHECKOUT_ERROR = "Import Failed";
export const IMPORT_SCHEMA_ERROR = "Import Failed";
export const IMPORT_ACCESS_ERROR = "Import Failed";
export const IMPORT_SUCCESS_SOFT_DELETE = "Import Successful";
export const IMPORT_SUCCESS_SOFTDELETED = "Import Successful";
export const BOM_SAVED_SUCCESS = "Import Successful"
export const BOM_SAVED_FAILURE = "Import Failed"
export const BOM_PCX_SAVED_SUCCESS = "Import Successful";
export const BOM_PCX_SAVED_FAILURE = "Import Failed";
export const BOM_GEMINI_SAVED_SUCCESS = "Import In Progress";
export const BOM_GEMINI_SAVED_FAILURE = "Import Failed";
export const PCX_INTEGRATION_SUCCESS = "Import Successful";
export const PCX_INTEGRATION_FAILED = "Import Failed";
export const IMPORT_DATA_ERROR = "Import Failed";
export const FILE_TYPE_ERROR = "File should be json";
export const FILE_SIZE_ERROR = "File size exceeded";
export const DUPLICATE_FILE_ERROR = "Duplicate file name";
export const READY_FOR_IMPORT_LABEL ="Ready for Import";
export const BOM_JSON_ID="BOM Header";
export const BOL_JSON_ID="BOL Header";
export const SUCCESS="Success";
export const error="Import Failed";
export const success="Import Successful";
export const CONCURRENCY_EXCEPTION = "Import Failed"